import { addDays, isAfter, isBefore, isSameDay, max, startOfDay, startOfWeek } from 'date-fns'
import { paymentDays } from 'constants/paymentDay'
import { IPaymentDay } from 'typescript/interfaces/paymentDay'

const DAYS_IN_WEEK = 7

interface IWeeklyScheduleDates {
  startDate: string
  nextPaymentDate: string
}

const toDay = (date: string | Date) => startOfDay(new Date(date))

const weekStartOf = (date: Date) => startOfWeek(date, { weekStartsOn: 1 })

const occurrenceInWeekOf = (weekStart: Date, paymentDay: IPaymentDay) => addDays(weekStart, paymentDays.indexOf(paymentDay))

const nextOccurrenceOf = (date: Date, paymentDay: IPaymentDay) => {
  const occurrence = occurrenceInWeekOf(weekStartOf(date), paymentDay)

  return isBefore(occurrence, date) ? addDays(occurrence, DAYS_IN_WEEK) : occurrence
}

export const isPaymentDueToday = ({ startDate, nextPaymentDate }: IWeeklyScheduleDates, today: Date = new Date()) => {
  const day = startOfDay(today)
  const next = toDay(nextPaymentDate)
  const previous = addDays(next, -DAYS_IN_WEEK)

  return isSameDay(next, day) || (isSameDay(previous, day) && !isBefore(previous, toDay(startDate)))
}

export const isEarlierInWeek = (paymentDay: IPaymentDay, today: Date = new Date()) =>
  isBefore(occurrenceInWeekOf(weekStartOf(startOfDay(today)), paymentDay), startOfDay(today))

export const getRescheduledPaymentDate = (
  { startDate, nextPaymentDate }: IWeeklyScheduleDates,
  paymentDay: IPaymentDay,
  today: Date = new Date()
) => {
  const day = startOfDay(today)
  const start = toDay(startDate)
  const weekStart = weekStartOf(day)
  const previous = addDays(toDay(nextPaymentDate), -DAYS_IN_WEEK)
  const isCollectedThisWeek = !isBefore(previous, start) && !isBefore(previous, weekStart) && !isAfter(previous, day)
  const earliest = max(isCollectedThisWeek ? [day, start, addDays(weekStart, DAYS_IN_WEEK)] : [day, start])

  return nextOccurrenceOf(earliest, paymentDay)
}
